<div [ngClass]="[ (showPopup && !startHiding) ? 'showField popup-level-' + openedPopupsCount: 'hideField']"
    class="js-field-container">

    <div [ngClass]="{'background' : showPopup}"></div>
    <div *ngIf="showPopup">
        <div class="left-title-bar"
            [ngClass]="[showRoundedCorner ? 'round-corner': '', isActivePopup() ?  'popup-header-select' : 'popup-header-deselect']">
            <!-- [ngClass]="[showRoundedCorner ? 'round-corner': '']"> -->
            <span class="vertical-text">{{"lbl_place" | translate}}</span>

        </div>
        <div class="main-modal" [ngClass]="showRoundedCorner ? 'round-corner': ''">
            <div class="header">
                <div class="head-title">
                </div>
                <span></span>
                <div class="tabs">
                    <span><button type="button" [ngClass]="{'tab-btn-disable': isPlaceEditorOpen}"
                            style="border-top-left-radius: 8px;" class="btn btn-tab element-over-hand"
                            (click)="openPlaceListTab()">{{"lbl_places" | translate}}</button></span>
                    <span><button type="button" [ngClass]="{'tab-btn-disable': !isPlaceEditorOpen}"
                            style="border-top-right-radius: 8px;" class="btn btn-tab" (click)="openPlaceEditorTab()">
                            +{{"lbl_add_place" | translate}}</button></span>
                </div>
            </div>
            <div class="body">

                <div class="page-title">{{addTitle}}</div>

                <!-- <div class="placelist"> -->
            <div class="place-list" >                  
                <app-mainlazyloading *ngIf="!isPlaceEditorOpen" [displayList]="list" [defaultItemIds]="selectedPlaces"
                    [filterTypes]="filterTypes" [isFullScreenPopUp]="false" [defaultImageType]="resourceType"
                    [popupWidth]="popupWidth" [deleteItemId]="deletePlaceId" (selectedItem)="selectedPlace($event)"
                    (editItem)="editPlace($event)" (reload)="reload($event)" (deleteItem)="deletePlace($event)">
                </app-mainlazyloading>
            </div>
                <!-- place editor compoenent  -->
                <app-place-editor *ngIf="isPlaceEditorOpen" [selectedPlace]="selectedItem" (cancel)="closePopup()"
                  (changePlaceList)="detectPlaceChange($event)"  (updatePlaceEvent)="setPlaceToEvent($event)"   ></app-place-editor>
            </div>

            <div class="footer" *ngIf="!isPlaceEditorOpen">
                <div [ngClass]="{'buttons': !isPlaceEditorOpen ,'place-editor-buttons': isPlaceEditorOpen}">
                    <!-- <span
                                        class="comp-navigation">{{multimediaPaneModel.ConnectionInfo[0].ResourceName}}</span>  -->
                    <span class="selected-place vertical-center" *ngIf="isSaveEnable && !placeDeselected">
                        {{"lbl_you_have_selected" | translate}}
                        {{selectedPlaceCaption}}
                    </span>
                    <span class="btn-check" *ngIf="isSaveEnable && !placeDeselected">
                        <img src="assets/input-form/btn-ok.png">
                    </span>
                    <span><button *ngIf="!isPlaceEditorOpen" type="button"
                            class="btn btn-primary button-footer-save btn-foot"
                            [ngClass]="(isSaveEnable)?'btn-active' : 'btn-disable'" (click)="selected()"
                            [disabled]="!isSaveEnable">{{"lbl_add_place" | translate}}</button></span>

                    <span><button *ngIf="!isPlaceEditorOpen" type="button"
                            class="btn btn-primary btn-foot btn-cancel element-over-hand"
                            (click)="cancel()">{{"lbl_cancel" | translate }}</button></span>
                </div>
            </div>
        </div>
    </div>

</div>